/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStorageFeeRetryReqVo
 */
export interface AdminStorageFeeRetryReqVo {
    /**
     * 费用归属日期列表，仅允许今天以前的日期，单次最多 31 天。
     * 费用归属日期列表，仅允许今天以前的日期，单次最多31天
     * @type {Array<string>}
     * @memberof AdminStorageFeeRetryReqVo
     */
    feeDates: Array<string>;
    /**
     * 补跑类型；不传或传空列表时补跑中国、韩国和橙火三类保管费。
     * 补跑类型：CHINA_STORAGE-中国仓储费，KOREA_STORAGE-韩国仓储费，ORANGE_FIRE_STORAGE-橙火保管费；不传或传空列表时补跑全部三类
     * @type {Array<string>}
     * @memberof AdminStorageFeeRetryReqVo
     */
    retryTypes?: Array<AdminStorageFeeRetryReqVoRetryTypesEnum>;
}


/**
 * @export
 */
export const AdminStorageFeeRetryReqVoRetryTypesEnum = {
    ChinaStorage: 'CHINA_STORAGE',
    KoreaStorage: 'KOREA_STORAGE',
    OrangeFireStorage: 'ORANGE_FIRE_STORAGE'
} as const;
export type AdminStorageFeeRetryReqVoRetryTypesEnum = typeof AdminStorageFeeRetryReqVoRetryTypesEnum[keyof typeof AdminStorageFeeRetryReqVoRetryTypesEnum];


/**
 * Check if a given object implements the AdminStorageFeeRetryReqVo interface.
 */
export function instanceOfAdminStorageFeeRetryReqVo(value: object): value is AdminStorageFeeRetryReqVo {
    if (!('feeDates' in value) || value['feeDates'] === undefined) return false;
    return true;
}

export function AdminStorageFeeRetryReqVoFromJSON(json: any): AdminStorageFeeRetryReqVo {
    return AdminStorageFeeRetryReqVoFromJSONTyped(json, false);
}

export function AdminStorageFeeRetryReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStorageFeeRetryReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'feeDates': json['feeDates'],
        'retryTypes': json['retryTypes'] == null ? undefined : json['retryTypes'],
    };
}

export function AdminStorageFeeRetryReqVoToJSON(json: any): AdminStorageFeeRetryReqVo {
    return AdminStorageFeeRetryReqVoToJSONTyped(json, false);
}

export function AdminStorageFeeRetryReqVoToJSONTyped(value?: AdminStorageFeeRetryReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'feeDates': value['feeDates'],
        'retryTypes': value['retryTypes'],
    };
}

